<script lang="ts">
  // The tracking script is proxied in vercel.json
  // Custom events with plausible: https://plausible.io/docs/custom-event-goals
  // import { browser } from '$app/environment';

  type SupportedDomains =
    | 'techlockdown.black'
    | 'techlockdown.red'
    | 'techlockdown.com'
    | 'members.techlockdown.com'
    | 'members.techlockdown.black'
    | 'dashboard.techlockdown.com'
    | 'dashboard.techlockdown.black';

  export let isDev: boolean = false;
  export let domain: SupportedDomains = isDev ? 'techlockdown.black' : 'techlockdown.com';
  export let trackingScriptPath: string = '/js/script.outbound-links.js';
  const trackingSrc = isDev ? `https://plausible.io${trackingScriptPath}` : trackingScriptPath;
  const server = import.meta.env.SSR;
  if (!server && window !== undefined) {
    window.plausible =
      window.plausible ||
      function () {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
  }
</script>

<svelte:head>
  <script defer data-domain={domain} src={trackingSrc}></script>
</svelte:head>
